import React from "react";
import EnrollmentForm from "../../../components/enrollments/EnrollmentForm";
export default function ManagerEnrollmentFormPage() {
    return <EnrollmentForm role="MANAGER" />;
}
